export default __webpack_public_path__ + "static/media/deauville03.89e1fc44.jpg";